import type { CTWDevProps, CTWProviderProps } from '../context/ctw-context';
import type { PatientResourceID, ThirdPartyID } from '../context/patient-provider';

export type ZapIFrameConfig = {
  CTWProviderProps: CTWProviderProps;
  PatientProviderProps: ThirdPartyID | PatientResourceID;
  devProps?: CTWDevProps;
};

export const ZapIFrameConfigMessageType = 'ZusAggregatedProfileIFrameConfig';
export const ZapIFrameReadyMessageType = 'ZusAggregatedProfileIFrameReady';
export const ZapOnResourceSaveMessageType = 'ZusAggregatedProfileOnResourceSave';
export const ZapOnEHRWritebackMessageType = 'ZusAggregatedProfileOnEHRWriteback';
export const ZapOnPatientSaveMessageType = 'ZusAggregatedProfileOnPatientSave';
export const ZapOnAddToRecordMessageType = 'ZusAggregatedProfileOnAddToRecord';
export const ZapOnConfigReceivedMessageType = 'ZusAggregatedProfileConfigReceived';
export const ZapTokenMessageType = 'ZusToken';
export const ZapTokenRequestMessageType = 'ZusTokenRequest';

export interface ZapMessage {
  type: string;
  payload: unknown;
}

export interface ZapIframeConfigMessage extends ZapMessage {
  type: typeof ZapIFrameConfigMessageType;
  payload: ZapIFrameConfig;
}

export interface ZapTokenMessage extends ZapMessage {
  type: typeof ZapTokenMessageType;
  payload: { accessToken: string };
}
